import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Chip,
} from '@mui/material';
import axios from 'axios';
import { format } from 'date-fns';

/** Purpose: browse and manage captured lead contacts. Why: teams need to follow up on prospects collected through bot interactions. */
export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeads();
  }, []);

  /** Purpose: Load fetch leads for the leads module. Why: The selected view needs current data to render or continue processing. */
  const fetchLeads = async () => {
    try {
      const response = await axios.get('/api/v1/leads');
      setLeads(response.data.leads || []);
    } catch (error) {
      console.error('Error fetching leads:', error);
    } finally {
      setLoading(false);
    }
  };

  /** Purpose: Perform get status color for the leads module. Why: Callers need a consistent result from this shared operation. */
  const getStatusColor = (status) => {
    const colors = {
      new: 'default',
      contacted: 'info',
      qualified: 'primary',
      converted: 'success',
      lost: 'error',
    };
    return colors[status] || 'default';
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Interest</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {leads.map((lead) => (
              <TableRow key={lead._id}>
                <TableCell>{lead.name || 'N/A'}</TableCell>
                <TableCell>{lead.phone}</TableCell>
                <TableCell>{lead.email || 'N/A'}</TableCell>
                <TableCell>{lead.interest || 'N/A'}</TableCell>
                <TableCell>
                  <Chip
                    label={lead.status}
                    color={getStatusColor(lead.status)}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {format(new Date(lead.createdAt), 'PPp')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
